import { H2 } from '@/common/ui'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/common/ui/dialog'
import { ConicArcSpinner } from '@/common/ui/spinner'
import { ONBOARDING_COPY } from '@/locales/en'
import { FC } from 'react'

type ApplicationRedirectPageProps = {
    enabled?: boolean
}

export const ApplicationRedirectPage: FC<ApplicationRedirectPageProps> = ({ enabled = true }) => {
    return (
        <Dialog open={!!enabled}>
            <DialogContent className="m-0 h-full w-full rounded-none grid-rows-[auto_1fr] grid gap-6 top-0 translate-y-0 pb-24 sm:pb-0 p-6 lg:p-6 z-[60]">
                <div className="w-full h-full flex items-center justify-center bg-white" style={{ minHeight: '100vh' }}>
                    <div className="max-w-[600px] px-10 py-12 bg-white flex flex-col justify-center items-center gap-12">
                        <DialogHeader>
                            <DialogTitle className="sr-only">{ONBOARDING_COPY.redirect}</DialogTitle>
                        </DialogHeader>
                        <div className="flex flex-col justify-center items-center gap-6">
                            <ConicArcSpinner size="lg" />
                            <H2 className="text-center text-Brand-Forest text-3xl font-normal font-['Serious_Sans'] leading-9 text-[#223A32]">
                                {ONBOARDING_COPY.redirect}
                            </H2>
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    )
}
